import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { RootState, WkblVideoState } from 'redux/reducers/type';
import {
  Button,
  ClickAwayListener,
  Grow,
  makeStyles,
  MenuList,
  Paper,
  Popper,
  Theme,
  Typography,
} from '@material-ui/core';
import { SelectIcon } from 'asset/images';
import { SearchCondition, OrderByOptions, SortOptions } from 'commons/constants/KeyFlowConstants';
import { OrderOptions } from 'components/SelectOptions';
import { OrderSelectProps } from 'components/Select/type';

const useStyles = makeStyles((theme: Theme) => ({
  sortOptionButton: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '167px',
    border: '1px solid #b6b6b6',
    borderRadius: 0,
    [theme.breakpoints.down('md')]: {
      width: '102px',
    },
  },
  popper: {
    zIndex: theme.zIndex.tooltip,
  },
  paper: {
    width: '167px',
    borderRadius: 0,
    [theme.breakpoints.down('md')]: {
      width: '102px',
    },
  },
  ellipsis: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

function OrderSelect({ asc, sort, onChangeAsc, onChangeSort }: OrderSelectProps) {
  const classes = useStyles();

  const [button, setButton] = useState<null | HTMLButtonElement>(null);
  const isOpen = useMemo(() => Boolean(button), [button]);

  const sortSearchCondition = useMemo(() => {
    return SortOptions.filter(({ value }) => value === sort)[0];
  }, [sort]);

  const orderSearchCondition = useMemo(() => {
    return OrderByOptions.filter(({ value }) => value === asc)[0];
  }, [asc]);

  const onOpenMenu = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    setButton(event.currentTarget);
  }, []);

  const onCloseMenu = useCallback(() => {
    setButton(null);
  }, []);

  return (
    <>
      <Button className={clsx(classes.sortOptionButton)} onClick={onOpenMenu}>
        <Typography className={clsx(classes.ellipsis)}>
          {orderSearchCondition.name} / {sortSearchCondition.name}
        </Typography>
        <img src={SelectIcon}></img>
      </Button>
      <Popper className={clsx(classes.popper)} open={isOpen} anchorEl={button} transition>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: 'center top',
            }}
          >
            <Paper className={clsx(classes.paper)}>
              <ClickAwayListener onClickAway={onCloseMenu}>
                <MenuList autoFocusItem={isOpen} id="menu-list-grow" onKeyDown={onCloseMenu}>
                  <OrderOptions
                    asc={asc}
                    sort={sort}
                    onClose={onCloseMenu}
                    onChangeAsc={onChangeAsc}
                    onChangeSort={onChangeSort}
                  />
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </>
  );
}

export default OrderSelect;
